import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import {
  Card, CardHeader, Table,
} from 'reactstrap';

import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import UUID from 'src/components/UUID';

/**
 * @param {object} props
 * @param {object} props.portfolio portfolio property Member's portfolio
 * @param {string} props.portfolio.uuid portfolio property member's portfolio's uuid
 * @param {number} props.portfolio.externalIdentifier portfolio property member's portfolio's ext id
 * @param {string} props.portfolio.title portfolio property member's portfolio's title
 * @param {object} props.portfolio.active portfolio property member's portfolio's active timerange
 * @param {number} props.portfolio.active.start portfolio property member's portfolio's active start
 * @param {number} props.portfolio.active.finish portfolio property member's portfolio's active
 * finish
 * @returns {React.ReactElement} - PropertyMemberPortfolioCard component
 */
function PropertyMemberPortfolioCard(props) {
  const { portfolio } = props || {};

  const {
    uuid, externalIdentifier, title, active,
  } = portfolio || {};

  const intl = useIntl();

  return (
    <Card className="mb-4">
      <CardHeader>
        {intl.formatMessage({ id: 'admin.admin_portfolio_property_member.admin_portfolio_property_member_show.portfolio.card.card_header.portfolio.label', defaultMessage: 'Portfolio' })}
      </CardHeader>
      <Table responsive>
        <tbody>
          <tr>
            <th scope="col">
              {intl.formatMessage({ id: 'admin.admin_portfolio_property_member.admin_portfolio_property_member_show.portfolio.card.card_body.head.title.label', defaultMessage: 'Title' })}
            </th>
            <th scope="col">
              <abbr title={intl.formatMessage({ id: 'admin.admin_portfolio_property_member.admin_portfolio_property_member_show.portfolio_card.card_body.head.id.abbr.title', defaultMessage: 'Identifier' })}>
                {intl.formatMessage({ id: 'admin.admin_portfolio_property_member.admin_portfolio_property_member_show.portfolio.card.card_body.head.id.label', defaultMessage: 'ID' })}
              </abbr>
            </th>
            <th scope="col">
              <abbr title={intl.formatMessage({ id: 'admin.admin_portfolio_property_member.admin_portfolio_property_member_show.portfolio_card.card_body.head.external_identifier.abbr.title', defaultMessage: 'External identifier' })}>
                {intl.formatMessage({ id: 'admin.admin_portfolio_property_member.admin_portfolio_property_member_show.portfolio.card.card_body.head.external_identifier.label', defaultMessage: 'Ext ID' })}
              </abbr>
            </th>
            <th scope="col">
              {intl.formatMessage({ id: 'admin.admin_portfolio_property_member.admin_portfolio_property_member_show.portfolio.card.card_body.head.active.label', defaultMessage: 'Active' })}
            </th>
          </tr>
          <tr>
            <th scope="row" colSpan={2}>
              <Link to={`/admin/portfolios/${uuid}`}>
                {title}
              </Link>
              <br />
              <UUID uuid={uuid} />
            </th>
            <td>{externalIdentifier}</td>
            <td aria-label="badge active">
              <BadgeActiveTimeRange active={active} />
            </td>
          </tr>
        </tbody>
      </Table>
    </Card>
  );
}

PropertyMemberPortfolioCard.propTypes = {
  portfolio: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    externalIdentifier: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    active: PropTypes.shape({
      start: PropTypes.number.isRequired,
      finish: PropTypes.number,
    }).isRequired,
  }).isRequired,
};

export default PropertyMemberPortfolioCard;
